export default __webpack_public_path__ + "static/media/walkthrough-step1-4K.5e64758f.jpg";